import { Selection } from '@/model'
import { Service } from '@/types/ServicePackage'

export function makePackageName (services: Service[]): string {
  return services
    .map(({ procedureCode, charges }) => `${procedureCode}:${charges}`)
    .sort()
    .join('|')
}

export function selectionsServices (selections: Selection[][]): Service[] {
  return selections
    .reduce((acc: Service[], selectedOptions): Service[] =>
      [
        ...acc,
        ...selectedOptions
          .filter(({ service }) => !!service)
          .map(({ service }): Service => service as Service)
      ], [])
}
